<div style="width: 100%">
  <rms-table [data]="SupplierRequests" [columns]="RequestColumns" [clickableRow]="true" (onRowClick)="onSelectRequest($event)" [IncludePaginator]="false"></rms-table>
</div>
